    <div class="container-fluid pl2rem pr2rem">
        <div class="row">
            <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-xs-12 col-12">
                <app-side-image-landing/> 
            </div> -->
            <div class="col-xl-12 col-lg-12 col-md-12 col-xs-12 col-12">
                <app-registerform-landing/>
            </div>
        </div> 
    </div>
    <div>
        <!-- <app-footer-landing/> -->
    </div>
